import React, { Component, PureComponent } from 'react';

import { connect } from 'react-redux';
import { reduxForm, initialize } from 'redux-form';
import humanize from 'humanize-string';
import _ from 'lodash';
import styled from 'styled-components';

import MessageForm from './MessageForm';
import SubmitButton from './SubmitButton';

import { deleteMessage, updateMessage } from '../actions';

import { LinearProgress, RaisedButton, FlatButton, MenuItem, IconButton, Dialog, CardText } from 'material-ui';
import IconMenu from 'material-ui/IconMenu';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import WarningIcon from 'material-ui/svg-icons/alert/warning';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import { grey50 } from 'material-ui/styles/colors';

const EditMessage = reduxForm({
    form: 'editMessage',
    asyncBlurFields: [],
    onSubmit: (values, dispatch, self) => {
        const onSuccess = response => {
            const { onSubmitSucceed } = self;
            if (onSubmitSucceed) {
                onSubmitSucceed(response);
            }
        };

        if (values.template) {
            for (const key in values.template) {
                if (values.template[key] === '') Reflect.deleteProperty(values.template, key);
            }
        }

        return dispatch(updateMessage(values)).then(onSuccess);
    },
})(MessageForm);

const LANGUAGES = {
    en: 'English',
    da: 'Danish',
    no: 'Norwegian',
    de: 'Deutsch',
    fi: 'Finish',
    th: 'Thai',
    se: 'Swedish',
    sc: 'Chinise simpl',
    tc: 'Chinise trad',
};

const columnWidth = {
    column2: 220,
    column3: 190,
    column4: 150,
    column5: 60,
};

const LanguagesWrapper = styled.div`
    display: flex;
    justify-content: center;

    span {
        padding: 0 2px;
        overflow: hidden;
        border-radius: 50%;
    }
`;

const PreviewWrapper = styled.div`
    h4 {
        margin-top: 10px;
        margin-bottom: 10px;
    }
`;
const PreviewWrapperTrigger = styled.div`
    display: flex;

    p {
        flex-grow: 1;
    }
`;

const PreviewList = styled.ul`
    li {
        margin-bottom: 12px;
    }
`;

const MessagePreviewRow = connect(
    (state, { id }) => ({
        message: _.get(state.requery.entities, ['messageTemplates', id]),
    }),
    (dispatch, { id }) => ({
        deleteMessage: () => dispatch(deleteMessage(id)),
        initializeEdit: message => dispatch(initialize('editMessage', message)),
    }),
)(
    class _MessagePreviewRow extends Component {
        state = {
            deleteDialogOpen: false,
            editDialogOpen: false,
            previewDialogOpen: false,
            displayDialogs: false,
            iconMenuOpen: false,
        };

        displayDialogs = () => {
            this.setState({ previewDialogOpen: false, displayDialogs: true });
        };

        toggleOpenIconMenu = () => this.setState({ iconMenuOpen: !this.state.iconMenuOpen });

        toggleOpenDeleteDialog = () =>
            this.setState({ deleteDialogOpen: !this.state.deleteDialogOpen, iconMenuOpen: false });

        toggleOpenPreviewDialog = () =>
            this.setState({ previewDialogOpen: !this.state.previewDialogOpen, iconMenuOpen: false });

        openEditDialog = () => {
            this.setState({ editDialogOpen: true, iconMenuOpen: false });
            this.props.initializeEdit(this.props.message);
        };

        closeEditDialog = () => {
            this.setState({ editDialogOpen: false });
        };

        render() {
            const { displayDialogs, deleteDialogOpen, editDialogOpen, previewDialogOpen, iconMenuOpen } = this.state;
            const { message, deleteMessage } = this.props;

            if (!message) {
                return null;
            }

            const { template, trigger, title, subtype } = message;

            const tableProps = { ...this.props };
            Reflect.deleteProperty(tableProps, 'message');
            Reflect.deleteProperty(tableProps, 'deleteMessage');
            Reflect.deleteProperty(tableProps, 'initializeEdit');

            const languages = _.isObject(template) ? Object.keys(template).sort() : [];

            return (
                <TableRow {...tableProps}>
                    <TableRowColumn onTouchTap={this.toggleOpenPreviewDialog}>{title}</TableRowColumn>
                    <TableRowColumn onTouchTap={this.toggleOpenPreviewDialog} style={{ width: columnWidth.column2 }}>
                        {humanize(trigger)}
                    </TableRowColumn>
                    <TableRowColumn onTouchTap={this.toggleOpenPreviewDialog} style={{ width: columnWidth.column3 }}>
                        {subtype}
                    </TableRowColumn>
                    <TableRowColumn
                        onTouchTap={this.toggleOpenPreviewDialog}
                        style={{
                            width: columnWidth.column4,
                            textAlign: 'center',
                        }}
                    >
                        <LanguagesWrapper>
                            {languages.map(lang => (
                                <span key={lang}>
                                    {lang}
                                    {/* {LANGUAGES[lang] || lang}: {template[lang]} */}
                                </span>
                            ))}
                        </LanguagesWrapper>
                    </TableRowColumn>
                    <TableRowColumn
                        style={{
                            width: columnWidth.column5,
                            paddingLeft: 6,
                            paddingRight: 6,
                        }}
                    >
                        <IconMenu
                            open={iconMenuOpen}
                            onRequestChange={this.toggleOpenIconMenu}
                            iconButtonElement={
                                <IconButton>
                                    <MoreVertIcon />
                                </IconButton>
                            }
                            onTouchTap={this.displayDialogs}
                        >
                            <MenuItem primaryText="Edit" leftIcon={<EditIcon />} onTouchTap={this.openEditDialog} />
                            <MenuItem
                                primaryText="Delete"
                                leftIcon={<DeleteIcon />}
                                onTouchTap={this.toggleOpenDeleteDialog}
                            />
                        </IconMenu>
                    </TableRowColumn>
                    {displayDialogs && (
                        <Dialog
                            open={deleteDialogOpen}
                            onRequestClose={this.toggleOpenDeleteDialog}
                            title={title}
                            actions={[
                                <RaisedButton
                                    key="Yes, delete"
                                    secondary
                                    onTouchTap={deleteMessage}
                                    label="Yes, delete"
                                />,
                                <FlatButton key="No" onTouchTap={this.toggleOpenDeleteDialog} label="No" />,
                            ]}
                        >
                            Are you sure you want to delete message template `{title}`?
                        </Dialog>
                    )}
                    ,
                    {displayDialogs && (
                        <Dialog
                            open={editDialogOpen}
                            onRequestClose={this.closeEditDialog}
                            autoScrollBodyContent
                            autoDetectWindowHeight
                            title={title}
                            actions={[
                                <SubmitButton key="Update" secondary form="editMessage" label="Update" />,
                                <FlatButton
                                    key="Cancel"
                                    secondary
                                    onTouchTap={this.closeEditDialog}
                                    label="Cancel"
                                    style={{ marginLeft: 5 }}
                                />,
                            ]}
                        >
                            <EditMessage onSubmitSuccess={this.closeEditDialog} />
                        </Dialog>
                    )}
                    <Dialog
                        open={previewDialogOpen}
                        onRequestClose={this.toggleOpenPreviewDialog}
                        autoScrollBodyContent
                        autoDetectWindowHeight
                        title={title}
                        actions={[
                            <RaisedButton
                                key="Edit"
                                primary
                                onTouchTap={() => {
                                    this.setState({ previewDialogOpen: false, displayDialogs: true });
                                    this.openEditDialog();
                                }}
                                label="Edit"
                            />,
                            <FlatButton
                                key="Cancel"
                                secondary
                                onTouchTap={this.toggleOpenPreviewDialog}
                                label="Cancel"
                                style={{ marginLeft: 5 }}
                            />,
                        ]}
                    >
                        <PreviewWrapper>
                            <PreviewWrapperTrigger>
                                <p>
                                    <strong>Trigger:</strong> {humanize(trigger)}
                                </p>
                                <p>
                                    <strong>Trigger subtype:</strong> {subtype}
                                </p>
                            </PreviewWrapperTrigger>
                            <h4>Text messages:</h4>
                            <PreviewList>
                                {languages.map(lang => (
                                    <li key={lang}>
                                        <strong>{LANGUAGES[lang] || lang}: </strong>
                                        {template[lang]}
                                    </li>
                                ))}
                            </PreviewList>
                        </PreviewWrapper>
                    </Dialog>
                </TableRow>
            );
        }
    },
);

class MessageList extends PureComponent {
    render() {
        const { items, responseStatus, isFinished } = this.props;

        if (!isFinished) {
            return <LinearProgress />;
        }

        const isOk = responseStatus === 200;

        if (!isOk) {
            return (
                <CardText
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'column',
                    }}
                >
                    <WarningIcon />
                    <p>Error while fetching messages</p>
                    <span>Status code: {responseStatus}</span>
                </CardText>
            );
        }

        if (!(Array.isArray(items) && items.length)) {
            return (
                <CardText>
                    <h3>Nothing found</h3>
                </CardText>
            );
        }

        return (
            <Table fixedHeader selectable={false} hoverable={false} height="80vh">
                <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                    enableSelectAll={false}
                    style={{ backgroundColor: grey50 }}
                >
                    <TableRow>
                        <TableHeaderColumn>Title</TableHeaderColumn>
                        <TableHeaderColumn style={{ width: columnWidth.column2 }}>Trigger</TableHeaderColumn>
                        <TableHeaderColumn style={{ width: columnWidth.column3 }}>Trigger subtype</TableHeaderColumn>
                        <TableHeaderColumn style={{ width: columnWidth.column4, textAlign: 'center' }}>
                            Languages
                        </TableHeaderColumn>
                        <TableHeaderColumn style={{ width: columnWidth.column5 }} />
                    </TableRow>
                </TableHeader>
                <TableBody displayRowCheckbox={false} showRowHover={false} deselectOnClickaway={false}>
                    {items.map(id => (
                        <MessagePreviewRow key={id} id={id} />
                    ))}
                </TableBody>
            </Table>
        );
    }
}

export default connect(({ requery }, { trigger }) => {
    const listKey = 'messageTemplates' + (trigger ? `/${trigger}` : '');
    const queryKey = 'GET:messageTemplates' + (trigger ? `/${trigger}` : '');

    return {
        items: requery.list[listKey],
        isFinished: _.get(requery.queries, [queryKey, 'isFinished']),
        responseStatus: _.get(requery.queries, [queryKey, 'status']),
    };
})(MessageList);



/** WEBPACK FOOTER **
 ** ../src/dash/front/messages/components/MessageList.js
 **/